<div class="holder">
  <h1 id="app_name">
    Basic Block
    Puzzle</h1>
    
    
  <button mat-raised-button id="start_button" routerLink="game">
    <i class="material-icons-round">play_arrow</i>
  </button>
</div>
  
<app-welcome (welcomeShow)="hideWelcome($event)" *ngIf="welcomeState"></app-welcome>